export enum ScheduledNotificationRange {
  TEN_MIN_BEFORE_START = 'TEN_MIN_BEFORE_START',
  THIRTY_MIN_AFTER_START = 'THIRTY_MIN_AFTER_START',
  ONE_HOUR_AFTER_START = 'ONE_HOUR_AFTER_START',
  ONE_HOUR_THIRTY_MIN_AFTER_START = 'ONE_HOUR_THIRTY_MIN_AFTER_START',
}

export type ScheduledNotificationType = {
  [orderNumber: string]: ScheduledNotificationRange
}
